
import React from "react";

import { Header } from '../../Components/Layout/Header.jsx'

export class NotFound extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return <div>
            <Header key="header" {...this.state} {...this.props}></Header>

            <div id="page-wrapper" className="white padding-2p-on-mobile border-on-tablet margin-1p-on-tablet">
                <div className="error-message margin-top  padding-sides-medium ">
                    <span className="icon ico-alert"></span>
                    <span>Stranica nije pronađena.</span>
                </div>
                <div className="margin-top margin-bottom clearfix">&nbsp;</div>
                <div className="margin-top margin-bottom clearfix">&nbsp;</div>
                <div className="margin-top margin-bottom clearfix">&nbsp;</div>
            </div>
        </div>
    }
};
